<template>
<div class="chapter">
<div class="inner_page">
<p></p>
<p></p>
<p class="titlepage"><span class="bold">DEATH IN<br/>
  A WHITE TIE</span></p>
<p></p>
<p></p>
<p></p>
<p class="author"><span class="bold">Ngaio Marsh</span></p>
<p></p>
<p></p>
<p></p>
<p class="print">Felony &amp; Mayhem Press • New York</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TitlePage.vue?3ac9188b